import { useState, useEffect } from "react";
import { REQUEST_STATUS, RequestStatus } from "../../../shared/consts";
import { fetchWordSuggestions } from "../word-suggestion-service";
import { Suggestion, WordSuggestionsResponse } from "../types";

type UseWordSuggestionsDialogResult = {
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  selectedDimension: string;
  setSelectedDimension: React.Dispatch<React.SetStateAction<string>>;
  wordSuggestions: Suggestion[];
  wordSuggestionsStatus: RequestStatus;
  clearValues: () => void;
};

export const useWordSuggestionDialog = (
  functionKey: string,
  lastWord: string
): UseWordSuggestionsDialogResult => {
  const [inputValue, setInputValue] = useState<string>(lastWord);
  const [selectedDimension, setSelectedDimension] = useState<string>("");
  const [wordSuggestions, setWordSuggestions] = useState<Suggestion[]>([]);
  const [wordSuggestionsStatus, setWordSuggestionsStatus] =
    useState<RequestStatus>(REQUEST_STATUS.IDLE);

  useEffect(() => {
    if (!inputValue.trim()) {
      setWordSuggestions([]);
      setWordSuggestionsStatus(REQUEST_STATUS.IDLE);
    }
  }, [inputValue]);

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!inputValue.trim()) return;
      try {
        setWordSuggestionsStatus(REQUEST_STATUS.LOADING);
        const data: WordSuggestionsResponse = await fetchWordSuggestions(
          inputValue,
          3,
          true,
          functionKey,
          selectedDimension
        );
        if (inputValue.trim()) {
          setWordSuggestions(data.suggestions || []);
          setWordSuggestionsStatus(REQUEST_STATUS.SUCCESS);
        } else {
          setWordSuggestions([]);
          setWordSuggestionsStatus(REQUEST_STATUS.IDLE);
        }
      } catch (err) {
        console.error(err);
        setWordSuggestionsStatus(REQUEST_STATUS.FAILURE);
      }
    };
    fetchSuggestions();
  }, [inputValue, selectedDimension, functionKey]);
  const clearValues = () => {
    setInputValue("");
    setSelectedDimension("");
    setWordSuggestions([]);
    setWordSuggestionsStatus(REQUEST_STATUS.IDLE);
  };
  return {
    inputValue,
    setInputValue,
    selectedDimension,
    setSelectedDimension,
    wordSuggestions,
    wordSuggestionsStatus,
    clearValues,
  };
};
